import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Conseil } from "../../../models/conseil";
import { ConseilService } from "../../../services/conseil.service";
import { TwitterService } from "../../../services/twitter.service";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-annonces',
    templateUrl: './conseil.component.html',
    styleUrls: ['./conseil.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConseilComponent implements OnInit {
  conseil$: Observable<Conseil>;

  contenu: any;
  conseil: Conseil;

  constructor(
    private route: ActivatedRoute,
    private conseilService: ConseilService,
    public sanitizer: DomSanitizer,
    private twitterService: TwitterService) {
  }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.conseil$ = this.conseilService.findById(id);
    this.conseil$.subscribe(conseil => {
      this.conseil = conseil;
      this.contenu = this.sanitizer.bypassSecurityTrustHtml(conseil.contenu);
      this.twitterService.initWidget();
    });
  }
}
